import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { MatDialog, MatDialogConfig } from '@angular/material';
import { environment } from '../../environments/environment';

import { MatSnackBar } from "@angular/material";
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';

import { PeliculaService } from '../services/pelicula.service';
import { PeliculaHorarioService } from '../services/pelicula-horario.service';
import { PeliculaHorario } from '../models/pelicula-horario';
@Component({
  selector: 'app-pelicula-horario-editor',
  templateUrl: './pelicula-horario-editor.component.html',
  styleUrls: ['./pelicula-horario-editor.component.css']
})
export class PeliculaHorarioEditorComponent implements OnInit {

  model: PeliculaHorario = new PeliculaHorario();

  models: PeliculaHorario[];

  pelicula_id;

  loading: boolean = false;

  tipos;
  espacios;

  boton: String = "Añadir";

  constructor(private modelService: PeliculaHorarioService, private peliculaService: PeliculaService, public dialog: MatDialog, private dialogRef: MatDialogRef<PeliculaHorarioEditorComponent>, @Inject(MAT_DIALOG_DATA) data, private snackBar: MatSnackBar) {
    this.pelicula_id = data.id;

    if (data.id != 0) {
      this.get(data.id);
    }
  }

  ngOnInit() {
    this.modelService.getTipo().subscribe(val => this.tipos = val);
    this.modelService.getEspacio().subscribe(val => this.espacios = val);
  }


  save() {
    this.loading = true;

    if (this.model.id == null || this.model.id == 0 || this.model.id == undefined) {

      this.modelService.add(this.model).subscribe(
        val => {
          this.loading = false;
          this.snackBar.open('Registro Guardado', '', {
            duration: 2000,
          });
          this.get(this.pelicula_id);
          this.model = new PeliculaHorario();
          this.model.pelicula_id = this.pelicula_id;
          this.boton = "Añadir";
        },
        error => {
          console.log(<any>error);
          this.snackBar.open('Intente de nuevo, ocurrio un error', '', {
            duration: 3000,
            panelClass: ['red-snackbar']
          });
          this.loading = false;
        });
    }
    else {

      this.modelService.edit(this.model).subscribe(
        val => {
          this.loading = false;
          this.snackBar.open('Registro Guardado', '', {
            duration: 2000,
          });
          this.get(this.pelicula_id);
          this.model = new PeliculaHorario();
          this.model.pelicula_id = this.pelicula_id;
          this.boton = "Añadir";
        },
        error => {
          console.log(<any>error);
          this.snackBar.open('Intente de nuevo, ocurrio un error', '', {
            duration: 3000,
            panelClass: ['red-snackbar']
          });
          this.loading = false;
        });

    }
  }


  get(id) {
    this.peliculaService.get(id).subscribe(
      val => {
        this.models = val.horarios;
        this.model.pelicula_id = id;
      },
      error => {
        console.log(<any>error);
      });

  }

  edit(id) {
    this.modelService.get(id).subscribe(
      val => {
        this.model = val;
        this.boton = "Editar";
      },
      error => {
        console.log(<any>error);
      });

  }
  new() {
    this.model = new PeliculaHorario();
    this.model.pelicula_id = this.pelicula_id;
    this.boton = "Añadir";
  }


  delete(id) {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '300px';

    const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(
      data => {
        if (data == true) {
          this.modelService.delete(id).subscribe(
            val => {
              this.get(this.pelicula_id);
              this.snackBar.open('Registro Eliminado', '', {
                duration: 2000,
              });
            });
        }
      }
    );

  }


  subtitulo() {
    if (this.model.subtitulo == true)
      this.model.subtitulo = false;
    else
      this.model.subtitulo = true;
  }
  close() {
    this.dialogRef.close();
  }

}
